import { EventHandler } from "../../util/event/EventHandler";
import { ResultCode } from "../common/controller/net/constant/Constants";
import { ProgressiveJackpotRequest } from "../common/controller/net/request/ProgressiveJackpotRequest";
import { AbstractHandler } from "../core/handler/AbstractHandler";
import { ProgressiveJackpotResult } from "./ProgressiveJackpotResult";
/**
 * ProgressiveJackpotHandler.ts
 */
export class ProgressiveJackpotHandler extends AbstractHandler {
    constructor(parameters, action, scope) {
        super();
        this.parameters = parameters;
        this.eventHandler = new EventHandler(action, scope);
    }
    destroy() {
        super.destroy();
        this.parameters = null;
        this.eventHandler = null;
    }
    run() {
        super.run();
        this.send();
    }
    send() {
        let request = new ProgressiveJackpotRequest(this.parameters);
        request.onSuccess(this.handleSuccess, this);
        request.onFailure(this.handleFailed, this);
        request.send();
    }
    handleSuccess(data) {
        this.handleAction(new ProgressiveJackpotResult(ResultCode.SUCCESS, data));
    }
    handleFailed(data) {
        this.handleAction(new ProgressiveJackpotResult(data.getResponseCode()));
    }
    handleAction(result) {
        this.eventHandler.call(result);
        this.destroy();
    }
}
//# sourceMappingURL=ProgressiveJackpotHandler.js.map